export default __webpack_public_path__ + "static/media/gold_star.37e0d862.svg";